<template>
  <!-- <el-popover placement="right" :width="400" trigger="click" :disabled="disabled == null? false:disabled">
    <template #reference>
      <el-input

          v-model="model"
          autocomplete="off"
          placeholder="请选择部门"
          :disabled="disabled == null? false:disabled"
      ></el-input>
    </template> -->
  <el-tree-select
      :style="style"
      ref="tree"
      class="tree"
      highlight-current:true
      placeholder="请选择部门"
      :data="depart"
      :render-after-expand="true"
      node-key="id"
      :props="defaultProps"
      :check-strictly=true
      v-model="value"
      filterable
      clearable
      default-expand-all
      :disabled="disabled == null? false:disabled"
  >
    <!-- @node-click="handleNodeClickEdit" -->
    <template #default="{ data  }">
      <div @click="handleNodeClickEdit(data.label,data.id)">{{ data.label }}</div>
    </template>
  </el-tree-select>

  <!-- </el-popover> -->
</template>
<script>

import {getDepartmentTree} from "@/request/BasicDataApi"

export default {
  name: "multiple depart select",
  data() {
    return {
      depart: [],
      defaultProps: {//tree格式
        children: "children",
        label: "label",
        id: "id",
      },
      value: ''
    }
  },
  props: [
    'model',
    'keys',
    'style', 'disabled'
  ],
  created() {
    getDepartmentTree().then((res) => {
      this.depart =[{label:"无", id:'', children: null}, ...res.data]
    });
    this.value = this.model
  },
  mounted() {
    this.value = this.model
    if (this.keys != null)
      this.$refs.tree.setCheckedKeys(JSON.parse(this.keys), false)
  },
  methods: {
    //修改单选部门节点
    handleNodeClickEdit(label, id) {
      this.$emit('id', id)
      this.$emit('name', label)
    },
  },
  watch: {
    'model'(e){
      this.value = e
    }
    // 'value'(e){
    //   console.log(e);
    //   this.$emit('id',e)
    //   this.$emit('name',  e.label)
    // }
    // 'keys'(){
    //   this.$refs.tree.setCheckedKeys(this.keys)
    // }
  }
}
</script>

<style scoped>

</style>
